import { IController, IWindowService } from 'angular';
import * as _ from 'lodash';
import { SdcWizardStepperService } from '../../../../../shared/services/sdc/sdc-wizard-stepper.service';
import { ISdcStore } from './../../../../../sdc/flux/sdc-store.interface';

const sdcKey = 'credit-gaps';

export class CreditGapsWizardStepperCtrl implements IController {
  static $inject: string[] = ['$scope', '$window', 'SDCStore', 'SdcWizardStepperService'];

  // bindings
  public currentSchool: any;
  public currentFilter: any;
  public stepper: any;
  public uiReady = false;

  // class properties
  constructor(
    private $scope,
    private $window: IWindowService,
    private SDCStore: ISdcStore,
    private SdcWizardStepperService: SdcWizardStepperService,
  ) {}

  $onInit(): void {
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.setUi();
        this.setListeners();
        this.$window.setTimeout(() => this.SdcWizardStepperService.init(sdcKey));
        this.uiReady = true;
      }
    });
  }

  private setListeners() {
    this.$scope.$listenTo(this.SDCStore, ['filter'], this.setUi.bind(this));
  }

  public setUi = () => {
    this.currentFilter = _.last(this.SDCStore.getFilter().cohort);
  };

  prevStep = this.SdcWizardStepperService.back;
  nextStep = this.SdcWizardStepperService.next;
}
